import AutocompleteViewFree from "./autocompleteViewFree";

import { withLabel } from "composants/withLabel";
import { AutocompleteProps } from "composants/autocomplete/AutoComplete";

export default withLabel<AutocompleteProps>()(AutocompleteViewFree);
